import React, { PropsWithChildren, ReactElement } from "react";

import * as styles from "./RefinementListWrapper.module.scss";

type Props = {
  title?: string | ReactElement;
  dataContentName?: string;
};

const RefinedListWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  title,
  dataContentName
}) => {
  return (
    <div data-content-name={dataContentName}>
      {title && <div className={styles.label}>{title}</div>}
      {children}
    </div>
  );
};

export default RefinedListWrapper;
